import { render, staticRenderFns } from "./ResDepartments.vue?vue&type=template&id=f996f1ba&scoped=true"
import script from "./ResDepartments.vue?vue&type=script&lang=js"
export * from "./ResDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f996f1ba",
  null
  
)

export default component.exports